import { render, staticRenderFns } from "./GenaralSettings.vue?vue&type=template&id=d8eb2952&scoped=true"
import script from "./GenaralSettings.vue?vue&type=script&lang=js"
export * from "./GenaralSettings.vue?vue&type=script&lang=js"
import style0 from "./GenaralSettings.vue?vue&type=style&index=0&id=d8eb2952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8eb2952",
  null
  
)

export default component.exports